var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualStudio2013(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2419,
    height: 2500,
    viewBox: "-0.002 -0.003 500.002 516.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.292 64.07L372.104 19.499l-194.08 189.002-116.873-88.967-44.441 22.351-.044 233.313 44.232 22.189 116.778-88.894 194.557 188.829 111.101-44.397-.042-388.855z",
    fill: "#68217a",
    stroke: "#fff",
    strokeWidth: 33.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.037 175.128L249.98 258.15l111.101 83.673-.044-166.695zM72.192 208.596l.066 99.858 55.483-50.267-55.549-49.591z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualStudio2013);
export default __webpack_public_path__ + "static/media/visual-studio-2013.bf694f6526d78023011f1906cc8387cc.svg";
export { ForwardRef as ReactComponent };